import { render, staticRenderFns } from "./KPICard.vue?vue&type=template&id=626d06c5"
import script from "./KPICard.vue?vue&type=script&lang=js"
export * from "./KPICard.vue?vue&type=script&lang=js"
import style0 from "./KPICard.vue?vue&type=style&index=0&id=626d06c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports